"use client";

import { Link } from "@chakra-ui/next-js";
import { Button, HStack } from "@chakra-ui/react";
// import { FaArrowRight } from "react-icons/fa6";

const EstimateSectionLinks = () => (
  <HStack mt="42px">
    <Button
      as={Link}
      data-ph-capture-attribute-btn-id="estimate-get-started"
      href="?start_action=hero_form"
      borderRadius="4px"
      bg="brand.secondary"
      py="16px"
      px="24px"
      h="50px"
      color="white"
      fontSize="14px"
      fontWeight="700"
      variant="primary"
    >
      Get Started
    </Button>
    {/* <Button
      as={Link}
      href="/about"
      h="50px"
      variant="ghost"
      rightIcon={<FaArrowRight />}
      _hover={{
        bg: "transparent",
        textDecoration: "none",
      }}
    >
      Learn More
    </Button> */}
  </HStack>
);

export default EstimateSectionLinks;
